module.exports = __webpack_public_path__ + "static/media/thorn_compote.85090a46.png";